// extracted by css-extract-rspack-plugin
export default {"buttons":"ActionButtons-module__buttons___o6dZi","zoom":"ActionButtons-module__zoom___Fugd7","disabled":"ActionButtons-module__disabled___kyvNo"};